import Mcsub from './mailchimp';

const newsletterForm = () => {
  const forms = document.querySelectorAll('.form-wrapper');
  const airReportForm = document.querySelector('.air-report .newsletter');

  if (airReportForm) {
    const showFormButton = document.querySelector('.newsletter-cta button');
    showFormButton.addEventListener('click', () => {
      airReportForm.classList.add('form-visible');
    });
  }

  forms.forEach((signup) => {
    new Mcsub(signup, {
      user: '78d138277d800268529d2fd8b',
      list: '823f780d00',
      callback: 'cb',
      reponse: '.form-response',
      onSuccess() {
        signup.classList.add('success');
      }
    });
  });
};
export default newsletterForm;
